import { render, staticRenderFns } from "./LogoLoading.vue?vue&type=template&id=4ae954f0&scoped=true"
var script = {}
import style0 from "./LogoLoading.vue?vue&type=style&index=0&id=4ae954f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae954f0",
  null
  
)

export default component.exports